var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartExportNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3237_3433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4442 12.0422C20.723 13.4678 21.8625 14.1806 22.2449 15.1111C22.5784 15.9228 22.5784 16.8497 22.2449 17.6614C21.8625 18.5919 20.723 19.3047 18.4442 20.7303C16.1654 22.1558 15.026 22.8686 14.091 22.7621C13.2754 22.6692 12.5346 22.2058 12.0526 21.487C11.5 20.6629 11.5 19.2373 11.5 16.3863C11.5 13.5352 11.5 12.1096 12.0526 11.2855C12.5346 10.5667 13.2754 10.1033 14.091 10.0104C15.026 9.90393 16.1654 10.6167 18.4442 12.0422Z",
    fill: "#72E0B2",
    stroke: "#72E0B2",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3237_3433"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartExportNode);
export default __webpack_public_path__ + "static/media/start-export-node.b136244d3584bc71970d11569d24ff8e.svg";
export { ForwardRef as ReactComponent };